const mutation = {
  setDashboardConfig(state, data) {
    state.dashboardConfig = data;
  },
  setDashboardParams(state, data) {
    state.dashboardParams = data;
  },
  setQuickSightDashboardConfig(state, data) {
    state.quickSightDashboardConfig = data;
  },
  setCategory(state, data) {
    state.category = data;
  },
  COUNT_LOADING(state, loading) {
    state.isCountLoading = loading;
  },
  COUNT_DATA(state, data) {
    state.count_data = data;
  },
  TRANSPORTER_LOADING(state, loading) {
    state.isTransporterLoading = loading;
  },
  TRANSPORTER_DATA(state, data) {
    state.transporter_data = data;
  },
  SLA_LOADING(state, loading) {
    state.isSlaLoading = loading;
  },
  SLA_DATA(state, data) {
    state.sla_data = data;
  },
  VEHICLETYPELOADING_LOADING(state, loading) {
    state.isVehicleTypeLoading = loading;
  },
  VEHICLETYPELOADING_DATA(state, loading) {
    state.vehicletype_data = loading;
  },
  VEHICLETYPEUTILIZEDLOADING_LOADING(state, loading) {
    state.isVehicleTypeUtiliLoading = loading;
  },
  VEHICLETYPEUTILIZED_DATA(state, loading) {
    state.isVehicleTypeUtili_data = loading;
  },
  KPI_LOADING(state, loading) {
    state.isKPILoading = loading;
  },
  KPI_DATA(state, data) {
    state.kpi_data = data;
  },
  TRANSPORTER_LIST_LOADING(state, loading) {
    state.isTransporterListLoading = loading;
  },
  TRANSPORTER_LIST_DATA(state, data) {
    state.transporterlist = data;
  },
};

export default mutation;
